import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription, map, of, interval } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { format } from 'date-fns';
import { ClrModal } from '@clr/angular';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';


@Component({
    selector: 'app-painel-info',
    templateUrl: './painel-info.component.html',
    styleUrls: ['./painel-info.component.css'],
    standalone: false
})
export class PainelInfoComponent {
  form: FormGroup;
  fieldBeingEdited!: string;
  editedValue: any;
  argentina!: any[];
  perfilVehicles: string[] = [
    'Pequeno',
    'Medio',
    'Grande',

  ];
  combustiveis: string[] = [
    'Diesel',
    'Gás',
    'Elétrico',

  ];
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: '',
    descarga: false
  };
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'Itens_Jetta';
  query2: string = 'Carriers';
  query3: string = 'tipos_Veiculos_Karrara';
  query4: string = 'items_Excel_Karrara';
  queryInterplantas: string = 'Operacao_Interplantas_Karrara';
  data: any;
  base: number = 3;
  ID: number = Date.now();
  local: string = "";
  contato: string = "";
  endereco: string = "";
  comentario: string = "";
  exponent: number = 22;
  $even: any;
  $odd: any;
  dataSource: any;
  dialogRef: any;
  items$!: Observable<any[]>;
  items: any[] = [];
  totalMR: any[] = [];
  totalMRSemArg: any[] = [];
  itemsSP: any[] = [];
  itemsSul: any[] = [];
  itemsArg: any[] = [];
  itemsInterplantas: any[] = [];
  itemsInterplantasAtrasadas: any[] = [];
  itemsInterplantasNaoFinalizados: any[] = [];
  itemsSPFinalizados: any[] = [];
  itemsSulFinalizados: any[] = [];
  itemsArgFinalizados: any[] = [];
  totalMRFinalizado: any[] = [];
  name!: string;
  animal!: string;
  dialogOpen = false;
  dialogTiposOpen = false;
  carrier!: any[];
  veiculos!: any[];
  teste!: boolean;
  startDate!: string;
  endDate!: string;
  milkRunSP: boolean = true;
  milkRunSul: boolean = true;
  milkRunArg: boolean = true;
  filteredItems!: any[];
  interplantas: any[] = [];
  filteredInterplantas: any[] = [];
  naoTerminadas: any[] = [];
  distanciaTotal: number = 0;
  pesoTotal: number = 0;
  pesoTotalInterplantas: number = 0;
  usuarioLogado!: UsuarioLogado;
  isCarrierTCMEnabled: boolean = true;
  isCarrierJSLEnabled: boolean = true;
  isCarrierJSLVWEnabled: boolean = true;
  isCarrierLOTSEnabled: boolean = true;
  isCarrierJSLARGEnabled: boolean = true;
  isCarrierEnabled: boolean = true;
  subscription: Subscription | undefined;
  private searchTextSubscription!: Subscription;
  hoje = new Date();
  dataFiltra2Dias!: string;
  dataFiltraInterplantas!: string;
  dataFiltraSul!: string;
  dataFiltraArg!: string;
  objFillingRate: number = 75;
  classFillingRate: string = "verde";
  objVeiculosGrandes: number = 90;
  classVeiculosGrandes: string = "";
  objJanelas: number = 90;
  classJanelas: string = "";
  objMR!: number;
  classMR: string = "";
  objInterplantas!: number;
  classInterplantas: string = "";
  periodoDia!: number;
  viagensInterplantasFinalizadas!: any[];
  localNumber!: number;
  propertyName!: string;
  viagensInterplantasTerminadas!: any[];
  viagensInterplantasTerminadasNumero!: number;
  pesoTotalTransportadoMR!: number;
  valorTotalTransportadoMR: number = 0;
  totalCostMR!: number;
  MRtotalizado!: number;
  qtdVeiculosGD!: number;
  totalEmissao!: number;
  tolerancia: number = 0.1; // 10%
  tolerancia30: number = 0.3; // 30%
  eficiencia!: number;
  porcentagemPontual!: number;
  porcentagemAtrasado!: number;
  porcentagemTotal!: number;
  classJanelasPontual!: string;
  classJanelasAtrasada!: string;
  classJanelasTotal!: string;
  // totalMRDeveriaFinalizar!: number;
  totalJanelasInterplantasObj!: number;
  searchText: string = 'All';
  viagensInterplantasNaoTerminadas!: any[];
  filterColumnDados: string = 'dataPainel';
  filterColumnOperacao: string = 'Janela';
  referenceDate!: string;
  numDays: number = 7;
  numDaysARG: number = 10;
  porcentagemPontualColeta!: number;
  porcentagemPontualEntrega!: number;
  porcentagemColetaPontual!: number;
  porcentagemColetaAtrasado!: number;
  porcentagemColetaTotal!: number;
  porcentagemEntregaPontual!: number;
  porcentagemEntregaAtrasado!: number;
  porcentagemEntregaTotal!: number;
  classJanelasColeta!: string;
  classJanelasEntrega!: string;
  valorUmColeta!: number;
  valorDoisColeta!: number;
  valorUmEntrega!: number;
  valorDoisEntrega!: number;
  totalJanelasValidasColeta!: number;
  totalJanelasValidasEntrega!: number;
  totalViagensValidas!: number;
  emissoesTotal!: number;
  emissao!: number;
  itemsValidosAteOMomento!: any[];
  itemsValidosAteOMomentoEntrega!: any[];
  classStatus!: string;
  itemsApresentar!: any;
  filterColumn: string = 'date';
  itemsSulTerminadas: any[] = [];
  itemsSPTerminadas: any[] = [];
  itemsTerminados!: any[];
  porcentagemFinalizadas!: number;
  entregue: any;
  coletada: any;
  itemEntregues!: any[];
  itemColetados!: any[];
  itemsApresentarInterplantas!: any[];
  dialogOpen2: boolean = false;
  viagensMRDeveriamFinalizarNaoFinalizou!: any[];
  itemsApresentarNaoFinalizados!: any[];
  dialogOpen3: boolean = false;

  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private http: HttpClient, private cdr: ChangeDetectorRef,
    private servicoAutenticacao: AutenticacaoService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({});
  }

  async ngOnInit(): Promise<void> {
    try {
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const day = today.getDate().toString().padStart(2, '0');
      this.endDate = `${year}-${month}-${day}`;
      this.startDate = `${year}-${month}-${day}`;

      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 10);
      const sevenDaysAgoYear = sevenDaysAgo.getFullYear();
      const sevenDaysAgoMonth = (sevenDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const sevenDaysAgoDay = sevenDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltraArg = `${sevenDaysAgoYear}-${sevenDaysAgoMonth}-${sevenDaysAgoDay}`;

      const twoDaysAgo = new Date(today);
      twoDaysAgo.setDate(today.getDate() - 1);
      const twoDaysAgoYear = twoDaysAgo.getFullYear();
      const twoDaysAgoMonth = (twoDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const twoDaysAgoDay = twoDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltra2Dias = `${twoDaysAgoYear}-${twoDaysAgoMonth}-${twoDaysAgoDay}`;

      const threeDaysAgo = new Date(today);
      threeDaysAgo.setDate(today.getDate() - 2);
      const threeDaysAgoYear = threeDaysAgo.getFullYear();
      const threeDaysAgoMonth = (threeDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const threeDaysAgoDay = threeDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltraSul = `${threeDaysAgoYear}-${threeDaysAgoMonth}-${threeDaysAgoDay}`;

      const diaAtual = new Date(today);
      diaAtual.setDate(today.getDate());
      const diaAtualYear = diaAtual.getFullYear();
      const diaAtualMonth = (diaAtual.getMonth() + 1).toString().padStart(2, '0');
      const diaAtualDay = diaAtual.getDate().toString().padStart(2, '0');
      this.dataFiltraInterplantas = `${diaAtualYear}-${diaAtualMonth}-${diaAtualDay}`;
      await this.getCarriersFromDynamoDB();
      await this.getVeiculosFromDynamoDB();
      await this.getUserLogado();
      await this.update();
      this.subscription = interval(2 * 60 * 1000).subscribe(async () => {
        console.log("atualizou")
        try {
          // Código de atualização aqui...
          await this.update();
        } catch (error) {
          console.error('Erro durante a atualização automática:', error);
        }
      });
    } catch (error) {
      console.error('Erro durante a execução do ngOnInit:', error);
    }
  }

  initializeForm(items: any) {
    Object.keys(this.form.controls).forEach((key) => {
      this.form.removeControl(key);
    });
    this.resetForm();
    items.forEach((item: {
      Chegada: any; Placa: any; Fornecedor: any; Janela: any; Passo: any;
    }, index: any) => {
      this.form.addControl(`${index}.Fornecedor`, new FormControl(item.Fornecedor));
      this.form.addControl(`${index}.Janela`, new FormControl(item.Janela));
      this.form.addControl(`${index}.Passo`, new FormControl(item.Passo));
      this.form.addControl(`${index}.Placa`, new FormControl(item.Placa));
      this.form.addControl(`${index}.Chegada`, new FormControl(item.Chegada));
    });
  }

  resetForm() {
    this.form.reset();
  }

  editDialog(items: any): void {
    // console.log(items)
    // console.log("entrou " )
    this.itemsApresentar = [];
    const compareDates = (a: { Janela: string }, b: { Janela: string }): number => {
      return new Date(a.Janela).getTime() - new Date(b.Janela).getTime();
    };
    items = items.sort(compareDates);
    // Ordenar os itens pelo valor da variável Janela
    this.itemsApresentar = items;
    console.log( this.itemsApresentar )
    this.initializeForm(this.itemsApresentar);
    this.dialogOpen = true;
    // console.log( this.dialogOpen )
  }

  editDialog2(items: any): void {
    // console.log("entrou 2 " )
    // console.log(items )
    this.itemsApresentarInterplantas = [];
    const compareDates = (a: { Janela: string }, b: { Janela: string }): number => {
      return new Date(a.Janela).getTime() - new Date(b.Janela).getTime();
    };
    items = items.sort(compareDates);
    // Ordenar os itens pelo valor da variável Janela
    this.itemsApresentarInterplantas = items;
    this.initializeForm(this.itemsApresentarInterplantas);
    this.dialogOpen2 = true;
  }

  editDialog3(items: any): void {
    // console.log("entrou 2 " )
    console.log(items)
    this.itemsApresentarNaoFinalizados = [];
    const compareDates = (a: { Janela: string }, b: { Janela: string }): number => {
      return new Date(a.Janela).getTime() - new Date(b.Janela).getTime();
    };
    items = items.sort(compareDates);
    // Ordenar os itens pelo valor da variável Janela
    this.itemsApresentarNaoFinalizados = items;
    this.initializeForm(this.itemsApresentarNaoFinalizados);
    this.dialogOpen3 = true;
  }


  async update() {
    await this.getItemsFromArgentina();
    await this.getItemsFromDynamoDB();
    await this.getProgramacaoInterplantasFromDynamoDB();
    this.filteredItems = await this.items.concat(this.itemsArg);
    this.applyDateFilter();
    await this.somarFluxosFinalizado();
    this.centerDialog();
    await this.calcularPorcentagemVeiculosGrandes()
    await this.calcularPorcentagemVeiculosMedios()
    await this.calcularPorcentagemVeiculosPequenos()
    await this.somarTotalDistancePercorrida()
    await this.calcularSomaCustoViagem()
    await this.somarQuantidades()
    await this.calcularMediaValoresValidos()
    await this.getPercentComentNotEmpty()
    // console.log(this.itemsSP)
    // console.log(this.itemsSul)
    // console.log(this.itemsArg)
  }

  async somarFluxosFinalizado() {
    const currentDate = new Date();
    this.pesoTotalTransportadoMR = 0;
    this.valorTotalTransportadoMR = 0;
    let somaTotalDistance = 0;
    this.MRtotalizado = 0;
    this.totalMR = []
    this.totalMRSemArg = []
    // this.totalMRFinalizado = []
    this.totalMR = this.totalMR.concat(this.itemsArg);
    this.totalMR = this.totalMR.concat(this.itemsSP);
    this.totalMR = this.totalMR.concat(this.itemsSul);
    this.MRtotalizado = this.totalMR.length;

    //****************************************************** TESTE  */
    // this.totalMRFinalizado = this.totalMRFinalizado.concat(this.itemsSPTerminadas);
    // this.totalMRFinalizado = this.totalMRFinalizado.concat(this.itemsSulTerminadas);
    // this.totalMRFinalizado = this.totalMRFinalizado.concat(this.itemsArgFinalizados);
    // this.totalMRFinalizado.filter(item => {
    //   if (this.isValorValido(item['JanelaDestino 1'])) {
    //     const dataSemZ = item['JanelaDestino 1'].slice(0, -1); // Remove o último caractere (Z)
    //     const originalDate = new Date(dataSemZ);
    //     const comparison = this.compareDates(originalDate.toString(), currentDate.toString());
    //     if (comparison < 0) {
    //       return(item)
    //     }
    //   }
    // })

    this.totalMR.forEach(objeto => {
      if (objeto.hasOwnProperty("Weight Loaded")) {
        if (!isNaN(parseFloat(objeto["Weight Loaded"]))) {
          this.pesoTotalTransportadoMR += parseFloat(objeto["Weight Loaded"]);
        } else {
          // Tratar o caso em que "Weight Loaded" não é um número válido
          console.error("A propriedade 'Weight Loaded' não é um número válido.");
        }
      }
    });
    this.pesoTotalTransportadoMR = this.pesoTotalTransportadoMR / 1000;
    this.pesoTotalTransportadoMR = Math.ceil(this.pesoTotalTransportadoMR);
    this.totalMR.forEach(objeto => {
      if (objeto.hasOwnProperty("Total Cost")) {
        if (!isNaN(parseFloat(objeto["Total Cost"]))) {
          this.valorTotalTransportadoMR += parseFloat(objeto["Total Cost"]);
        } else {
          // Tratar o caso em que "Total Cost" não é um número válido
          console.error("A propriedade 'Total Cost' não é um número válido.");
        }
      }
    });
    this.valorTotalTransportadoMR = this.valorTotalTransportadoMR / 1000;
    this.valorTotalTransportadoMR = Math.ceil(this.valorTotalTransportadoMR);
    // Função auxiliar para somar os valores válidos da chave 'Total Distance'
    for (const item of this.totalMR) {
      if (this.isNumeroValido(item['Total Distance'])) {
        somaTotalDistance += item['Total Distance'];
      }
      this.distanciaTotal = somaTotalDistance;
    }
    await this.somarEmissoesVeiculos(this.totalMR);
    await this.calcularEmissaoCO2(this.emissoesTotal, this.pesoTotalTransportadoMR);
  }

  somarEmissoesVeiculos(items: any[]) {
    this.emissoesTotal = 0;
    for (const item of items) {
      const valorValido = this.isNumeroValido(item.emissaoTotal) ? item.emissaoTotal : 0;
      this.emissoesTotal += valorValido;
    }
  }

  calcularEmissaoCO2(emissaoTotal: number, pesoTotal: number) {
    this.emissao = 0;
    this.emissao = emissaoTotal / pesoTotal;
    this.emissao = Math.ceil(this.emissao)
  }

  compareDates(date1str: string, date2str: string): number {
    date1str = date1str.replace("Z", "");
    const date1 = new Date(date1str);
    const date2 = this.parseDateString(date2str);

    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    if (timestamp1 < timestamp2) {
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      return 1; // date1 é posterior a date2
    } else {
      return 0; // date1 é igual a date2
    }
  }

  compareDatesSemHoras(date1str: string, date2str: string): number {
    if (date1str)
      date1str = date1str.replace("Z", "");
    const date1 = this.removeTimeFromDate(new Date(date1str));
    const date2 = this.removeTimeFromDate(this.parseDateString(date2str));

    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    if (timestamp1 < timestamp2) {
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      return 1; // date1 é posterior a date2
    } else {
      return 0; // date1 é igual a date2
    }
  }

  removeTimeFromDate(date: Date): Date {
    date.setHours(0, 0, 0, 0);
    return date;
  }

  parseDateString(dateStr: string) {
    if (!dateStr.includes("T")) {
      dateStr += "T00:00:00";
    }
    return new Date(dateStr);
  }

  compareMultipleTimeStrings(...timeStrings: string[]): number {
    let result = 0;
    for (let i = 0; i < timeStrings.length - 1; i++) {
      const comparison = this.compareTimeStrings(timeStrings[i], timeStrings[i + 1]);

      if (comparison !== 0) {
        result = comparison;
        break; // Para assim que encontrar uma comparação não igual
      }
    }
    return result;
  }

  findLargestTimeName(...timeObjects: { name: string, time: string }[]) {
    let largestTime = "";
    let largestTimeValue = "1970-01-01T00:00:00.000Z";
    for (const timeObject of timeObjects) {
      if (!largestTimeValue || this.compareTimeStrings(timeObject.time, largestTimeValue) > 0) {
        largestTimeValue = timeObject.time;
        largestTime = timeObject.name;
      }
    }
    return { name: largestTime, time: largestTimeValue, largestTimeValue };
  }

  compareTimeStrings(timeString1: string, timeString2: string): number {
    const dataHora = new Date(timeString1); // Converte a string em um objeto de data
    const hours1 = dataHora.getUTCHours(); // Obtém as horas em UTC
    const minutes1 = dataHora.getUTCMinutes(); // Obtém os minutos em UTC     
    const dataHora2 = new Date(timeString2); // Converte a string em um objeto de data
    const hours2 = dataHora2.getUTCHours(); // Obtém as horas em UTC
    const minutes2 = dataHora2.getUTCMinutes(); // Obtém os minutos em UTC 
    const totalMinutes1 = hours1 * 60 + minutes1;
    const totalMinutes2 = hours2 * 60 + minutes2;
    if (totalMinutes1 < totalMinutes2) {
      return -1; // timeString1 é anterior a timeString2
    } else if (totalMinutes1 > totalMinutes2) {
      return 1; // timeString1 é posterior a timeString2
    } else {
      return 0; // timeString1 é igual a timeString2
    }
  }

  calcularPeriodoDia(): number {
    const now: Date = new Date();
    const totalMinutesInDay: number = 24 * 60; // Total de minutos em um dia (24 horas * 60 minutos)
    const minutesPassed: number = now.getHours() * 60 + now.getMinutes(); // Minutos que já passaram no dia
    const percentageOfDay: number = minutesPassed / totalMinutesInDay; // Porcentagem do dia que passou
    if (percentageOfDay < 0.25) {
      return 1;
    } else if (percentageOfDay < 0.5) {
      return 1;
    } else if (percentageOfDay < 0.75) {
      return 2;
    } else {
      return 3;
    }
  }

  isDateValid(dateString: string) {
    // Separar a string em componentes de dia, mês e ano
    const dateComponents = dateString.split('-');
    // Verificar se há três componentes (dia, mês e ano)
    if (dateComponents.length !== 3) {
      return false;
    }
    const year = parseInt(dateComponents[0], 10);
    const month = parseInt(dateComponents[1], 10);
    const day = parseInt(dateComponents[2], 10);
    // Verificar se os componentes são números válidos
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return false;
    }
    // Criar um objeto Date e verificar se ele representa uma data válida
    const dateObject = new Date(year, month - 1, day); // O mês é base 0 (janeiro é 0, fevereiro é 1, etc.)
    // Verificar se o objeto Date representa uma data válida
    return (
      dateObject.getFullYear() === year &&
      dateObject.getMonth() === month - 1 &&
      dateObject.getDate() === day
    );
  }


  isDateInRange(date: Date, startDate: string, endDate: string): boolean {
    const rangeStartDate = new Date(startDate);
    const rangeEndDate = new Date(endDate);
    const dateYear = date.getFullYear();
    const dateMonth = date.getMonth();
    const dateDay = date.getDate();
    return (
      date >= new Date(rangeStartDate.getFullYear(), rangeStartDate.getMonth(), rangeStartDate.getDate()) &&
      date <= new Date(rangeEndDate.getFullYear(), rangeEndDate.getMonth(), rangeEndDate.getDate(), 23, 59, 59, 999) &&
      dateYear == rangeStartDate.getFullYear() &&
      dateMonth == rangeStartDate.getMonth() &&
      dateDay == rangeStartDate.getDate()
    );
  }

  async filterByDateRange(startDate: string, endDate: string): Promise<any[]> {
    const rangeStartDate = new Date(startDate);
    const rangeEndDate = new Date(endDate);
    // Adjust rangeEndDate to the end of the selected day (23:59:59)
    rangeEndDate.setHours(23);
    rangeEndDate.setMinutes(59);
    rangeEndDate.setSeconds(59);
    const filteredItems = await this.items.filter((item) => {
      const itemDate = new Date(item.date);
      return itemDate >= rangeStartDate && itemDate <= rangeEndDate;
    });
    const argentinaItems = await this.itemsArg.filter((item) => {
      const itemDate = new Date(item.date);
      return itemDate >= rangeStartDate && itemDate <= rangeEndDate;
    });
    return [...filteredItems, ...argentinaItems];
  }

  async filterByDateRangeInterplantas(startDate: string, endDate: string): Promise<any[]> {
    const rangeStartDate = new Date(startDate);
    const rangeEndDate = new Date(endDate);
    // Adjust rangeEndDate to the end of the selected day (23:59:59)
    rangeEndDate.setHours(23);
    rangeEndDate.setMinutes(59);
    rangeEndDate.setSeconds(59);
    const filteredItems = await this.interplantas.filter((item) => {
      const itemDate = new Date(item["Janela 1"]);
      return itemDate >= rangeStartDate && itemDate <= rangeEndDate;
    });
    return filteredItems;
  }

  editPlaca(item: any, fieldName: string) {
    if (!this.isValorValido(item[fieldName])) {
      const newValue = prompt(`Insert a value for ${fieldName}:`);
      if (newValue !== null) {
        item[fieldName] = newValue;
        this.salvarField(item); // Call salvar function after editing the field
      }
    }
  }

  InsereComent(item: any, fieldName: string) {
    const newValue = prompt(`Insert a value for ${fieldName}:`);
    if (newValue !== null) {
      item[fieldName] = newValue;
      this.salvarField(item); // Call salvar function after editing the field
    }
  }

  async getPercentComentNotEmpty() {
    this.eficiencia = 0;
    const totalItems = this.totalMR.length;
    const itemsWithComent = await this.totalMR.filter(item => this.hasComent(item)).length;
    let media = 100 - ((itemsWithComent / totalItems) * 100);
    if (!isNaN(media)) {
      media = media;
    } else {
      media = 0;
    }
    this.eficiencia = Math.ceil(media);
  }

  editField(item: any, fieldName: string) {
    if (!this.isValorValido(item[fieldName])) {
      let newValue = prompt(`Insert a value for ${fieldName}:`);
      // Verifica se o valor é válido e não é nulo
      if (newValue !== null && newValue.trim() !== '') {
        // Remove as vírgulas do valor inserido
        const cleanedValue = newValue.replace(',', '.');
        // Converte o valor para o tipo number
        const numericValue = parseFloat(cleanedValue);
        // Verifica se é um número válido
        if (!isNaN(numericValue)) {
          item[fieldName] = numericValue;
          this.salvarField(item); // Chama a função salvarField após editar o campo
        } else {
          alert(`Invalid value for ${fieldName}. Please enter a valid number.`);
        }
      }
    }
  }

  isValorValido(value: any): boolean {
    return value !== '' && value !== null && value !== undefined;
  }

  calcularMediaValoresValidos(): number {
    let soma = 0;
    let contador = 0;
    for (const item of this.totalMR) {
      if (this.isValorValido(item['Weight Loaded'])) {
        const veiculo = this.findVeiculoByModelo(item['Transport Type']);
        if (veiculo && this.isValorValido(veiculo.peso)) {
          soma += item['Weight Loaded'] / veiculo.peso;
          contador++;
        }
      }
    }
    return contador > 0 ? (soma / contador) * 100 : 0;
  }

  calcularMaiorValor(item: any, veiculo: any): number {
    const pesoLoaded = this.isValorValido(item['Weight Loaded']) ? ((item['Weight Loaded'] / veiculo.peso) * 100) : 0;
    const cubage = this.isValorValido(item.Cubage) ? ((item.Cubage / veiculo.volume) * 100) : 0;
    return Math.max(pesoLoaded, cubage);
  }

  calcularMediaMaiorValor(): number {
    let soma = 0;
    let contador = 0;
    for (const item of this.totalMR) {
      const veiculo = this.findVeiculoByModelo(item['Transport Type']);
      if (veiculo) {
        const maiorValor = this.calcularMaiorValor(item, veiculo);
        soma += maiorValor;
        contador++;
      }
    }
    let media = contador > 0 ? soma / contador : 0;
    media = Math.ceil(media)
    if (media >= this.objFillingRate) {
      this.classFillingRate = "verde";
    } else if (media * (1 + this.tolerancia) >= this.objFillingRate) {
      this.classFillingRate = "amarelo";
    } else {
      this.classFillingRate = "vermelho";
    }
    if (media > 100) {
      media = 100;
    } else {
      media = media;
    }
    return media;
  }

  valorExisteNoModelo(transportType: string): boolean {
    return this.veiculos.some(veiculos => veiculos.modelo == transportType);
  }

  async applyDateFilter() {
    // Apply filter only when both startDate and endDate are selected
    if (this.startDate && this.endDate) {
      this.filteredItems = await this.filterByDateRange(this.startDate, this.endDate);
      this.filteredInterplantas = await this.filterByDateRangeInterplantas(this.startDate, this.endDate);
    } else {
      // Otherwise, show all items
      this.filteredItems = [...this.items, ...this.itemsArg];
    }
  }

  veiculoDialog(item: any): void {
    this.item.ID = item.ID
    this.item.modelo = item['Transport Type'];
    this.item.transportadora = item.transportadora;
    this.item.perfil = item.perfil;
    this.item.combustivel = item.combustivel;
    this.item.emissoes = item.emissoes;
    this.dialogTiposOpen = true;
  }

  async salvarVeiculo() {

    if (this.item.ID == undefined) {
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      //console.log(formattedDate);
      this.item = {
        "ID": formattedDate.toString(),
      }
    }
    delete this.item.contato;
    delete this.item.descarga;
    delete this.item.endereco;
    delete this.item.latitude;
    delete this.item.longitude;
    delete this.item.local;
    this.item.tableName = this.query3
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    await this.dynamodbService.salvar(jsonArray, this.query3, this.urlAtualiza).subscribe(async response => {
      await this.ngOnInit();
    }, error => {
      console.log(error);
    });
    this.dialogTiposOpen = false;
  }

  async salvarField(item: any) {
    const jsonArray = [item];

    await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
      await this.getItemsFromDynamoDB();
    }, error => {
      console.log(error);
    });
    this.dialogOpen = false;
  }

  calcularSomaCustoViagem(): number {
    let soma = 0;
    for (const item of this.totalMR) {
      const totalCost = parseFloat(item['Total Cost']);
      if (!isNaN(totalCost)) {
        soma += totalCost;
      }
    }
    this.totalCostMR = soma / 1000;
    return Math.ceil(this.totalCostMR);
  }
  // Função auxiliar para somar as quantidades de '1' e '2' em todas as chaves específicas
  isValorValidoEhUmOuDois(value: any): boolean {
    return this.isValorValido(value) && (value == '1' || value == '2');
  }
  isValidDate(dateStr: string) {
    const date = new Date(dateStr);
    return !isNaN(date.getTime());
  }

  // Função auxiliar para somar as quantidades de '1' e '2' em todas as chaves específicas
  somarQuantidades() {//: { valorUm: number, valorDois: number, totalItensValidos: number } {
    this.itemsValidosAteOMomento = [];
    this.itemsValidosAteOMomentoEntrega = [];
    this.viagensMRDeveriamFinalizarNaoFinalizou = [];
    this.itemsInterplantasAtrasadas = [];
    this.totalMRFinalizado = [];
    this.itemColetados = [];
    this.itemEntregues = [];
    const currentDate = new Date();
    this.porcentagemPontualColeta = 0
    this.porcentagemPontualEntrega = 0
    this.porcentagemAtrasado = 0
    this.porcentagemTotal = 0
    this.valorUmColeta = 0;
    this.valorDoisColeta = 0;
    this.valorUmEntrega = 0;
    this.valorDoisEntrega = 0;
    this.totalJanelasValidasColeta = 0;
    this.totalJanelasValidasEntrega = 0;
    this.totalViagensValidas = 0;
    this.totalJanelasInterplantasObj = 0;
    this.coletada = 0;
    this.entregue = 0;

    for (const item of this.totalMR) {
      const chavesColetas = [
        'Passo Fornecedor1',
        'Passo Fornecedor2',
        'Passo Fornecedor3',
        'Passo Fornecedor4'
      ];
      // for (const chave of chavesColetas) 
      chavesColetas.forEach((chave, indice) => {
        const valorCh = parseFloat(item[chave])
        if (this.isValorValidoEhUmOuDois(valorCh)) {
          this.coletada++;
          // console.log(item)
          if (valorCh == 1) {
            this.valorUmColeta++;
          } else if (valorCh == 2) {
            this.valorDoisColeta++;
            console.log(item)

            this.itemColetados.push({
              'Fornecedor': item[`Fornecedor ${indice + 1}`],
              'Janela': item[`Janela ${indice + 1}`],
              'Passo': item[`Passo Fornecedor${indice + 1}`],
              'Placa': item.Plate,
              'Chegada': item[`Time Passo Fornecedor${indice + 1}`]
            });
            // console.log(this.itemColetados)
          }
        }
      });

      const chavesEntregas = [
        'Passo Destino1',
        'Passo Destino2',
        'Passo Destino3',
        'Passo Destino4'
      ];

      chavesEntregas.forEach((chaveD, indice) => {
        const chaveValor = parseFloat(item[chaveD]);
        if (this.isValorValidoEhUmOuDois(chaveValor)) {
          this.entregue++;
          if (chaveValor === 1) {
            this.valorUmEntrega++;
          } else if (chaveValor === 2) {
            // console.log(item)
            console.log(item.ID);
            console.log(item.Plate);
            console.log(item);
            console.log(chaveValor);
            let chegadaDestino;
            if(item[`Destino ${indice + 1}`].includes("LCB")){
              chegadaDestino = item.ChegadaLCB
            }else if(item[`Destino ${indice + 1}`].includes("SCANIA")){
              chegadaDestino = item.ChegadaSCANIA
            }
            this.itemEntregues.push({
              'Fornecedor': item[`Destino ${indice + 1}`],
              'Janela': item[`JanelaDestino ${indice + 1}`],
              'Passo': item[`Passo Destino${indice + 1}`],
              'Placa': item.Plate,
              'Chegada': chegadaDestino
              // 'Indice': indice  // Adicione o índice ao objeto
            });
            console.log(this.itemEntregues);
            this.valorDoisEntrega++;
          }
        }
      });
    }

    const chavesJanelasColeta = [
      'Janela 1',
      'Janela 2',
      'Janela 3',
      'Janela 4'
    ];
    for (const [indiceItem, item] of this.totalMR.entries()) {
      let index = 0;
      let janela = '';
      let location = '';
      let passo = '';
      for (const [indice, chave] of chavesJanelasColeta.entries()) {
        if (this.isDateValid(item.date)) {
          if (this.isValorValido(item[chave])) {
            const originalDateString = item.date;
            const timeStringToAdd = item[chave];
            const originalDate = new Date(originalDateString);
            const newDate = this.addTimeStringToDate(originalDate, timeStringToAdd);
            const date1 = new Date(newDate);
            const date2 = new Date(currentDate);
            const comparison = this.compareDates(newDate.toString(), currentDate.toString());
            if (comparison < 0) {
              index = indice + 1;
              janela = item[chave];
              location = item['Fornecedor ' + index];
              passo = item['Passo Fornecedor' + index];
              this.itemsValidosAteOMomento.push({ 'Fornecedor': location, 'Janela': janela, 'Passo': passo });
              this.totalJanelasValidasColeta++;
            }
          }
        }
      }
    }
    const chavesJanelasEntrega = [
      'JanelaDestino 1',
      'JanelaDestino 2',
      'JanelaDestino 3', // Adicione aqui as outras chaves específicas
      'JanelaDestino 4'
    ];
    for (const [indiceItem, item] of this.totalMR.entries()) {
      let indexEntrega = 0;
      let janelaEntrega = '';
      let locationEntrega = '';
      let passoEntrega = '';
      for (const [indice, chave] of chavesJanelasEntrega.entries()) {
        if (this.isDateValid(item.date)) {
          if (this.isValorValido(item[chave])) {
            const originalDateString = item.date;
            const timeStringToAdd = item[chave];
            const originalDate = new Date(originalDateString);
            const newDate = this.addTimeStringToDate(originalDate, timeStringToAdd);
            const comparison = this.compareDates(newDate.toString(), currentDate.toString());
            if (comparison < 0) {
              // console.log(item.Plate);
              // console.log(comparison);
              // console.log(newDate.toString());
              // console.log(currentDate.toString());
              indexEntrega = indice + 1;
              janelaEntrega = item[chave];
              locationEntrega = item['Destino ' + indexEntrega];
              passoEntrega = item['Passo Destino' + indexEntrega];
              const novoItem = {
                Fornecedor: locationEntrega,
                Janela: janelaEntrega,
                Passo: passoEntrega
              };
              this.itemsValidosAteOMomentoEntrega.push(novoItem);
              this.totalJanelasValidasEntrega++;
            }
          }
        }
      }
    }
    for (const item of this.totalMR) {
      // //console.log(this.totalMR.length)
      const janela1 = item["JanelaDestino 1"] != null && item["JanelaDestino 1"] != undefined ? item["JanelaDestino 1"] : "1970-01-01T00:00:00.000Z";
      const janela2 = item["JanelaDestino 2"] != null && item["JanelaDestino 2"] != undefined ? item["JanelaDestino 2"] : "1970-01-01T00:00:00.000Z";
      const janela3 = item["JanelaDestino 3"] != null && item["JanelaDestino 3"] != undefined ? item["JanelaDestino 3"] : "1970-01-01T00:00:00.000Z";
      const janela4 = item["JanelaDestino 4"] != null && item["JanelaDestino 4"] != undefined ? item["JanelaDestino 4"] : "1970-01-01T00:00:00.000Z";

      const largestTimeName = this.findLargestTimeName(
        { name: "JanelaDestino 1", time: janela1 },
        { name: "JanelaDestino 2", time: janela2 },
        { name: "JanelaDestino 3", time: janela3 },
        { name: "JanelaDestino 4", time: janela4 }
      )
      if (this.isDateValid(item.date)) {
        if (this.isValorValido(item[largestTimeName.name])) {
          const JanelaDateString = item.date;
          const timeStringToAdd = item[largestTimeName.name];
          const originalDate = new Date(JanelaDateString);
          const newDate = this.addTimeStringToDate(originalDate, timeStringToAdd);
          const comparison = this.compareDates(newDate.toString(), currentDate.toString());
          if (comparison < 0) {
            if (
              item.Finalizada !== true &&
              item.Finalizada !== "True" &&
              item.Finalizada !== "true" &&
              item.FinalizadaManual !== true &&
              (
                (
                  item['Destino 1'] && // Verifica se 'Destino 1' tem um valor
                  item['Destino 1'].toLowerCase().includes('scania') && 
                  item.ChegadaSCANIA === undefined
                ) ||
                (
                  item['Destino 1'] && // Verifica se 'Destino 1' tem um valor
                  item['Destino 1'].toLowerCase().includes('lcb') && 
                  item.ChegadaLCB === undefined
                ) ||
                (
                  item['Destino 2'] && // Verifica se 'Destino 2' tem um valor
                  item['Destino 2'].toLowerCase().includes('scania') && 
                  item.ChegadaSCANIA === undefined
                ) ||
                (
                  item['Destino 2'] && // Verifica se 'Destino 2' tem um valor
                  item['Destino 2'].toLowerCase().includes('lcb') && 
                  item.ChegadaLCB === undefined
                )
              )
            ) {
              // console.log(newDate)
              this.viagensMRDeveriamFinalizarNaoFinalizou.push({
                // item
                'Fornecedores': item['Fornecedor 1'] ? item['Fornecedor 1'] : '' + item['Fornecedor 2'] ? ',' + item['Fornecedor 2'] : '' + item['Fornecedor 3'] ? ',' + item['Fornecedor 3'] : '',
                'Destinos': item['Destino 1'] ? item['Destino 1'] : '' + item['Destino 2'] ? ',' + item['Destino 2'] : '',
                'Passo': item['Passo Destino 1'],
                'Janela': item['JanelaDestino 1'],
                'Placa': item.Plate,
              });
            }
            if (item.Finalizada == true ||
              item.Finalizada == "True" ||
              item.Finalizada == "true" ||
              item.FinalizadaManual == true ||
              item.ChegadaLCB ||
              item.ChegadaSCANIA) {
              this.totalMRFinalizado.push(item)
              // console.log(newDate)
            }
            this.totalViagensValidas++;

          }
        }
      }
    }
    // console.log("Finalizadas",this.totalMRFinalizado.length)
    // console.log("NAO finalizadas",this.viagensMRDeveriamFinalizarNaoFinalizou.length)
    // console.log("total ",this.totalViagensValidas)


    this.objMR = this.totalViagensValidas;
    if (this.totalMRFinalizado.length >= this.objMR) {
      this.classMR = "verde";
    } else if (this.totalMRFinalizado.length * (1 + this.tolerancia30) >= this.objMR) {
      this.classMR = "amarelo";
    } else {
      this.classMR = "vermelho";
    }

    for (const item of this.itemsInterplantas) {
      if (this.isValorValido(item['Janela'])) {
        const dataSemZ = item['Janela'].slice(0, -1); // Remove o último caractere (Z)
        const originalDate = new Date(dataSemZ);
        const comparison = this.compareDates(originalDate.toString(), currentDate.toString());
        // return (this.compareDatesSemHoras(item['Janela'], today.toISOString()) == 0) && item.PassoEntrega > 0
        if (comparison < 0) {
          // console.log(item)
          if (!item.PassoEntrega || item.PassoEntrega < 1) {
            this.itemsInterplantasAtrasadas.push(item)
          }
          // console.log(item.Janela)
          this.totalJanelasInterplantasObj++;
        }
      }
    }

    this.objInterplantas = this.totalJanelasInterplantasObj;
    if (this.viagensInterplantasFinalizadas.length >= this.objInterplantas) {
      this.classInterplantas = "verde";
    } else if (this.viagensInterplantasFinalizadas.length * (1 + this.tolerancia) >= this.objInterplantas) {
      this.classInterplantas = "amarelo";
    } else {
      this.classInterplantas = "vermelho";
    }

    this.porcentagemColetaPontual = Math.ceil((this.valorUmColeta / this.coletada) * 100)
    this.porcentagemColetaAtrasado = Math.ceil((this.valorDoisColeta / this.coletada) * 100)
    this.porcentagemColetaTotal = Math.ceil(((this.valorUmColeta + this.valorDoisColeta) / this.coletada) * 100)
    this.porcentagemColetaPontual = this.porcentagemColetaPontual > 100 ? 100 : this.porcentagemColetaPontual

    this.porcentagemEntregaPontual = Math.ceil((this.valorUmEntrega / this.entregue) * 100)
    this.porcentagemEntregaAtrasado = Math.ceil((this.valorDoisEntrega / this.entregue) * 100)
    this.porcentagemEntregaTotal = Math.ceil(((this.valorUmEntrega + this.valorDoisEntrega) / this.entregue) * 100)

    this.porcentagemFinalizadas = Math.ceil(((this.totalMRFinalizado.length) / this.totalViagensValidas) * 100)
    this.porcentagemFinalizadas = this.porcentagemFinalizadas > 100 ? 100 : this.porcentagemFinalizadas;

    if (!Number.isNaN(this.porcentagemEntregaTotal)) {
      this.porcentagemEntregaTotal = this.porcentagemEntregaTotal;
    } else {
      this.porcentagemEntregaTotal = 0;
    }
    if (!Number.isNaN(this.porcentagemEntregaPontual)) {
      this.porcentagemEntregaPontual = this.porcentagemEntregaPontual;
    } else {
      this.porcentagemEntregaPontual = 0;
    }
    if (!Number.isNaN(this.porcentagemColetaPontual) && isFinite(this.porcentagemColetaPontual)) {
      this.porcentagemColetaPontual = this.porcentagemColetaPontual;
    } else {
      this.porcentagemColetaPontual = 0;
    }

    if (this.porcentagemColetaPontual >= this.objJanelas) {
      this.classJanelasColeta = "verde";
    } else if (this.porcentagemColetaPontual * (1 + this.tolerancia) >= this.objJanelas) {
      this.classJanelasColeta = "amarelo";
    } else {
      this.classJanelasColeta = "vermelho";
    }

    if (this.porcentagemEntregaPontual >= this.objJanelas) {
      this.classJanelasEntrega = "verde";
    } else if (this.porcentagemEntregaPontual * (1 + this.tolerancia) >= this.objJanelas) {
      this.classJanelasEntrega = "amarelo";
    } else {
      this.classJanelasEntrega = "vermelho";
    }

    if (this.porcentagemAtrasado >= this.objJanelas) {
      this.classJanelasAtrasada = "vermelho";
    } else {
      this.classJanelasAtrasada = "vermelho";
    }

    if (this.porcentagemTotal >= this.objJanelas) {
      this.classJanelasTotal = "verde";
    } else if (this.porcentagemTotal * (1 + this.tolerancia) >= this.objJanelas) {
      this.classJanelasTotal = "amarelo";
    } else {
      this.classJanelasTotal = "vermelho";
    }
  }

  getRowClass(status: string): string {
    if (status == '1') {
      return 'verde'
    } else if (status == '2') {
      return 'vermelho'
    } else if (status == undefined) {
      return 'amarelo'
    } else {
      return 'vermelho'
    }
  }

  addTimeStringToDate(baseDate: Date, timeString: string): Date {
    if (timeString.includes("T")) {
      let dateTransform = new Date(timeString);
      return new Date(dateTransform.getTime() + 3 * 60 * 60 * 1000)
    } else {
      const [hours, minutes] = timeString.split(":").map(Number);
      const newDate = new Date(baseDate);
      // Ajuste do fuso horário
      newDate.setUTCHours(hours + newDate.getTimezoneOffset() / 60);
      newDate.setMinutes(minutes);
      return newDate;
    }
  }

  isNumeroValido(value: any): boolean {
    return typeof value == 'number' && !isNaN(value) && isFinite(value);
  }

  somarTotalDistancePercorrida(): number {
    let somarTotalDistancePercorrida = 0;
    let viagensFaltantes = this.totalMR.filter(item => item.Finalizada != true && item.Finalizada != "True" && item.Finalizada != "true" && item.FinalizadaManual != true)
    for (const item of viagensFaltantes) {
      if (this.isNumeroValido(item['Total Distance'])) {
        somarTotalDistancePercorrida += item['Total Distance'];
      }
    }
    return this.distanciaTotal - somarTotalDistancePercorrida;
  }

  somarWeightLoaded(): number {
    let somaWeightLoaded = 0;
    for (const item of this.totalMR) {
      if (this.isNumeroValido(item['Weight Loaded'])) {
        somaWeightLoaded += item['Weight Loaded'];
      }
    }
    this.pesoTotal = somaWeightLoaded / 1000;
    return Math.ceil(this.pesoTotal);
  }

  hasComent(item: any): boolean {
    return item.Coment !== '' && item.Coment !== null && item.Coment !== undefined;
  }

  async salvar() {
    if (this.item.ID == undefined) {
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      //console.log(formattedDate);
      this.item = {
        "ID": formattedDate.toString(),
        "contato": this.item.contato,
        "endereco": this.item.endereco,
        "local": this.item.local,
        "latitude": this.item.latitude,
        "longitude": this.item.longitude,
        "descarga": this.item.descarga
      }
    }

    this.item.tableName = this.query
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
      await this.getItemsFromDynamoDB();
    }, error => {
      console.log(error);
    });
    this.dialogOpen = false;
  }

  cancel(): void {
    this.dialogOpen = false;
    this.dialogTiposOpen = false;
  }

  findVeiculoByModelo(modelo: string): any {
    return this.veiculos.find(veiculo => veiculo.modelo == modelo);
  }

  calcularPorcentagemVeiculosPequenos(): number {
    const totalVeiculos = this.totalMR.length;
    const veiculosPequenos = this.totalMR.filter(item => {
      const veiculo = this.findVeiculoByModelo(item['Transport Type']);
      return veiculo && veiculo.perfil == 'Pequeno';
    }).length;
    return (veiculosPequenos / totalVeiculos) * 100;
  }

  calcularPorcentagemVeiculosMedios(): number {
    const totalVeiculos = this.totalMR.length;
    const veiculosMedios = this.totalMR.filter(item => {
      const veiculo = this.findVeiculoByModelo(item['Transport Type']);
      return veiculo && veiculo.perfil == 'Medio';
    }).length;
    return (veiculosMedios / totalVeiculos) * 100;
  }

  calcularPorcentagemVeiculosGrandes(): number {
    const totalVeiculos = this.totalMR.length;
    const veiculosGrandes = this.totalMR.filter(item => {
      const veiculo = this.findVeiculoByModelo(item['Transport Type']);
      return veiculo && veiculo.perfil == 'Grande';
    }).length;
    this.qtdVeiculosGD = (veiculosGrandes / totalVeiculos) * 100;
    if (!isNaN(this.qtdVeiculosGD)) {
      this.qtdVeiculosGD = this.qtdVeiculosGD;
    } else {
      this.qtdVeiculosGD = 0;
    }
    this.qtdVeiculosGD = Math.ceil(this.qtdVeiculosGD);
    if (this.qtdVeiculosGD >= this.objVeiculosGrandes) {
      this.classVeiculosGrandes = "verde";
    } else if (this.qtdVeiculosGD * (1 + this.tolerancia) >= this.objVeiculosGrandes) {
      this.classVeiculosGrandes = "amarelo";
    } else {
      this.classVeiculosGrandes = "vermelho";
    }
    return Math.ceil(this.qtdVeiculosGD);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  centerDialog(): void {
    const dialogRefElement = this.dialogRef?.containerInstance?.hostElement;
    if (dialogRefElement) {
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const dialogWidth = dialogRefElement.clientWidth;
      const dialogHeight = dialogRefElement.clientHeight;
      const top = Math.max(0, (windowHeight - dialogHeight) / 2);
      const left = Math.max(0, (windowWidth - dialogWidth) / 2);
      dialogRefElement.style.top = `${top}px`;
      dialogRefElement.style.left = `${left}px`;
    }
  }

  async getItemsFromDynamoDB(): Promise<void> {
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    const today = new Date();
    // console.log(today.toDateString())
    // console.log(today.toISOString())
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.query, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.items = items
            this.items.forEach(item => {
              if (item.description) {
              } else {
                // console.log(item)
              }
            })

            this.itemsSP = this.items
              .filter(item => {
                try {
                  return ((item.description.includes("SP") || item.description.includes("TCM"))
                    && (this.compareDatesSemHoras(item['JanelaDestino 1'], today.toISOString()) == 0) && this.isValidDate(item.date));
                } catch {
                  console.log("Erro na propriedade Description")
                }
              });

            this.itemsSPTerminadas = this.itemsSP
              .filter(item => {
                return (
                  item.Finalizada == true ||
                  item.Finalizada == "True" ||
                  item.Finalizada == "true" ||
                  item.FinalizadaManual == true)
              });
            // console.log(this.dataFiltraSul)
            this.itemsSul = this.items
              .filter(item => {
                try {
                  return (item.description.includes("SUL")
                    && (this.compareDatesSemHoras(item['JanelaDestino 1'], today.toISOString()) == 0) && this.isValidDate(item.date));
                } catch {
                  console.log("Erro na propriedade Description")
                }
              });
            this.itemsSulTerminadas = this.itemsSul
              .filter(item => {
                return (
                  item.Finalizada == true ||
                  item.Finalizada == "True" ||
                  item.Finalizada == "true" ||
                  item.FinalizadaManual == true)
              }).filter(item => {
                let dateStringSemZ = item['JanelaDestino 1'].replace("Z", "");
                let date = new Date(dateStringSemZ);
                const itemDate = new Date(date);
                const todayDate = new Date();
                // Verifica se as datas têm o mesmo dia, mês e ano
                const sameDate = itemDate.getDate() === todayDate.getDate() &&
                  itemDate.getMonth() === todayDate.getMonth() &&
                  itemDate.getFullYear() === todayDate.getFullYear();
                return sameDate;
              });
            // console.log(this.itemsSPTerminadas)
            // console.log(this.itemsSulTerminadas)
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async getProgramacaoInterplantasFromDynamoDB(): Promise<void> {
    const today = new Date();
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.queryInterplantas, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          ////console.log(items)
          if (Array.isArray(items)) {
            this.interplantas = items
              .filter(item => item.ViagemCompleta != true && item.ViagemCompleta != "True" && item.ViagemCompleta != "true" && item.viagemCancelada != true)
              .map(item => ({ ...item, checked: false }));
            this.itemsInterplantas = await items
              .filter(item => item.viagemCancelada != true);
            this.itemsInterplantas = this.itemsInterplantas
              .filter(item => {
                return (this.compareDatesSemHoras(item['Janela'], today.toISOString()) == 0)
              })
            this.viagensInterplantasFinalizadas = await items
              .filter(item => {
                return (this.compareDatesSemHoras(item['Janela'], today.toISOString()) == 0) && item.PassoEntrega > 0
              }).filter(item => {
                if (this.isValorValido(item['Janela'])) {
                  const dataSemZ = item['Janela'].slice(0, -1); // Remove o último caractere (Z)
                  const originalDate = new Date(dataSemZ);
                  const comparison = this.compareDates(originalDate.toString(), today.toString());
                  if (comparison < 0) {
                    return (item)
                  }
                }
              })
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getVeiculosFromDynamoDB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query3, this.urlConsulta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculos = items.map(item => ({ ...item, checked: false }));
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromArgentina(): Promise<void> {
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    const today = new Date();
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.query4, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDaysARG)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            // this.argentina = await items
            //   .filter(item => this.shouldIncludeArgentina(item))
            //   .map(item => ({ ...item, checked: false }));
            // this.cdr.detectChanges();
            this.itemsArg = items
              .filter(item => {
                return ((item.description.includes("ARG") || item.description.includes("EMBALAGEM"))
                  && this.compareDatesSemHoras(item['JanelaDestino 1'], today.toISOString()) == 0 && this.isValidDate(item.date));
              });
            this.itemsArgFinalizados = this.itemsArg
              .filter(item =>
                item.Finalizada == true ||
                item.Finalizada == "True" ||
                item.Finalizada == "true" ||
                item.FinalizadaManual == true)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  shouldIncludeArgentina(item: any): boolean {
    const description = item.description ? item.description.toLowerCase() : '';
    if (this.milkRunArg && description.includes('arg')) {
      return true;
    }
    return false;
  }

  async getCarriersFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query2, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carrier = items.map(item => ({ ...item, checked: false }));
              this.cdr.detectChanges();
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async deleteItem(Item: any, urlDeleta: string, query: string): Promise<void> {
    const ID = Item.ID;
    await this.dynamodbService.deleteItem(ID, this.urlAtualiza, Item.tableName).subscribe(
      response => {
        setTimeout(() => {
          this.ngOnInit();
        }, 1200); // Ajuste o tempo de atraso conforme necessário
      },
      error => {
        // Lógica para lidar com erros durante a deleção do item
      }
    );
  }

  milkRunSPFilter() {
    //console.log("clicou")
    if (this.milkRunSP == true) {
      this.milkRunSP = false;
    } else {
      this.milkRunSP = true;
    }
  }

  milkRunSulFilter() {
    if (this.milkRunSul == true) {
      this.milkRunSul = false;

    } else {
      this.milkRunSul = true;
    }
  }

  milkRunArgFilter() {
    if (this.milkRunArg == true) {
      this.milkRunArg = false;
    } else {
      this.milkRunArg = true;
    }
  }

  async getUserLogado() {
    this.usuarioLogado = await this.servicoAutenticacao.obterUsuarioLogado()
    await this.enableFields();
    await this.enableFieldsTCM();
    await this.enableFieldsLOTS();
    await this.enableFieldsJSL();
    await this.enableFieldsJSLARG();
    await this.enableFieldsJSLVW();
  }

  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "TCM")) {
      this.isCarrierEnabled = false;
    }
  }

  enableFieldsTCM() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "TCM")) {
      this.isCarrierTCMEnabled = false;
    }
  }

  enableFieldsJSL() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL")) {
      this.isCarrierJSLEnabled = false;
    }
  }

  enableFieldsJSLARG() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-ARG")) {
      this.isCarrierJSLARGEnabled = false;
    }
  }

  enableFieldsLOTS() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "LOTS")) {
      this.isCarrierLOTSEnabled = false;
    }
  }

  enableFieldsJSLVW() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-VW")) {
      this.isCarrierJSLVWEnabled = false;
    }
  }

}
